// Mobile filter drawer: one flat panel. Dawn nests each filter behind a
// slide-over sub-screen; kodama-collection.css unwraps those into normal
// flow, and this script (a) keeps every filter group open - including after
// the facets re-render on every filter change - and (b) swallows the summary
// clicks so Dawn's sub-screen navigation (focus trap + panel slide) never
// runs.
(function () {
  var flatten = function () {
    document.querySelectorAll('.mobile-facets__details:not([open])').forEach(function (details) {
      details.setAttribute('open', '');
    });
  };

  // Capture phase: runs before Dawn's own summary handlers.
  document.addEventListener(
    'click',
    function (event) {
      var summary =
        event.target.closest && event.target.closest('.mobile-facets__details > summary');
      if (!summary) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  // Backdrop tap closes the drawer. The panel itself is pointer-events:all,
  // so a click whose target IS the .mobile-facets overlay can only be the
  // dimmed area (CSS re-enables its pointer events while open).
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('mobile-facets')) return;
    var closeButton = document.querySelector('.mobile-facets__wrapper .mobile-facets__close');
    if (closeButton) closeButton.click();
  });

  var wire = function () {
    flatten();
    // Collection pages and the search page use different hosts; fall back to
    // body so the drawer works anywhere facets render.
    var host =
      document.getElementById('main-collection-filters') ||
      document.getElementById('main-search-filters') ||
      document.body;
    // attributes:true matters - Dawn strips [open] from the filter groups
    // when the drawer reopens, which is an attribute change, not childList.
    new MutationObserver(flatten).observe(host, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  };

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
})();
